import {createAction} from "@reduxjs/toolkit";

export const setHomepage = createAction('SET_HOMEPAGE');